export default "skymp5-front/4f184c0824ece6bdde3da3a484bd3842.png";